import React from 'react'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { Card, Icon } from '@arnsbogroup/react-voicearchive'
import backgroundImage from './backgroundImage.jpg'

export const QualityCheckCard = ({ children, ...props }) => {
  return (
    <Card
      {...props}
      className='flex break-inside-avoid bg-gray-100'
    >
      <div
        style={{ backgroundImage: `url(${backgroundImage})` }}
        className="bg-cover hidden flex-shrink-0 h-full w-1/3 xl:block"
      />

      <div className="p-5">
        <div className="flex items-center space-x-2 mb-4">
          <Icon icon="badge-check" className="text-positive" />
          <h2 className="text-base font-semibold text-gray-800">
            <FormattedMessage {...messages.title} />
          </h2>
        </div>

        <div className="space-y-3 text-sm">
          {[
            {
              title: messages.creativeChecked,
              desc: messages.creativeCheckedDescription,
            },
            {
              title: messages.qualityChecked,
              desc: messages.qualityCheckedDescription,
            },
            {
              title: messages.nativeChecked,
              desc: messages.nativeCheckedDescription,
            },
          ].map((item, idx) => (
            <div
              key={idx}
              className="flex items-start space-x-3"
            >
              <Icon
                icon="check"
                className="text-positive mt-0.5 flex-shrink-0"
              />
              <div>
                <div className="font-medium text-gray-800">
                  <FormattedMessage {...item.title} />
                </div>
                <div className="text-gray-600">
                  <FormattedMessage {...item.desc} />
                </div>
              </div>
            </div>
          ))}
        </div>

        {children && (
          <div className="mt-4 pt-4 border-t border-gray-200">
            {children}
          </div>
        )}
      </div>
    </Card>
  )
}
